import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import * as S from "./styles";

export function VendaItens({data, key}) {

    return (
       <S.Container>
            <div className='vendaSingle font-secondary-xt w-[250px] flex flex-col items-center justify-center'>
                <p className="text-lg">Nº do pedido:</p>
                <p><strong>{data.numero_pedido}</strong></p>
            </div>
            <div className='divide'></div>
            <div className='vendaSingle font-secondary-xt w-[250px] flex flex-col items-center justify-center'>
                <p className="text-lg">Descrição:</p>
                <p>
                    <strong>{data.descricao}</strong>
                </p>
            </div>
            <div className='divide'></div>
            <div className='vendaSingle font-secondary-xt w-[250px] flex flex-col items-center justify-center'>
                <p className="text-lg">Cadastrado em:</p>
                <p>
                    <strong>{data.data_contrato}</strong>
                </p>
            </div>
            <div className={`pontos font-secondary-xt ${data.status}`}>
                <p className="text-lg">Status</p>
                <p style={{textTransform: 'capitalize'}}>{data.status}</p>
            </div>
       </S.Container>
    );
}
